{
  "salon-search-form-advance-dialog": {
    "buttons": {
      "cancel": "Zrušit",
      "save": "Uložit"
    },
    "text": {
      "title": "Předběžný filtr",
      "kilometer": "Kilometry",
      "only-salon-with-discount": "Pouze sleva",
      "only-salon-with-discount-description": "Zobrazit pouze salón se slevou na služby",
      "radius": "Poloměr",
      "radius-description": "Jak daleko by měly být salony od požadovaného místa",
      "sort-by": "Seřadit podle",
      "sort-by-distance": "Vzdálenosti",
      "sort-by-distance-description": "Nejprve se zobrazí salón nejblíže požadovanému místu",
      "sort-by-rating": "Hodnocení",
      "sort-by-rating-description": "Nejprve se zobrazí nejlépe hodnocený salón"
    }
  }
}
